import { render } from "./budget-wrapper.vue?vue&type=template&id=dd8ea144&ts=true"
import script from "./budget-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./budget-wrapper.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__